import React from "react";
import LevelGroupListItemContainer from "../levelGroups/LevelGroupListItemContainer";

export default function ClassroomContents({ levelGroups }) {
  return levelGroups?.map((levelGroup, index) => (
    <LevelGroupListItemContainer key={index} levelGroup={levelGroup} />
  ));
}
